import React from "react";
import {
  Row,
  Container,
  Button,
  Modal,
  Spinner,
  Form,
  Col,
} from "react-bootstrap";
import { v1 as uuid } from "uuid";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { emailBody } from "../helpers";
import { phoneCodes } from "../helpers/phoneCodes";
import { sendEmail } from "../helpers/sendEmail";
import { connect } from "react-redux";
import _ from "lodash";
import DateRangePickerField from "../elements/redux-form-elements/DateRangePicker";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import ReactGA from "react-ga";

//import { subscribe } from "../../actions/subscirbe";

class EnquiryForm extends React.Component {
  state = {
    token: null,
    messageFlag: false,
  };

  async componentDidMount() {
    const token = await this.props.googleReCaptchaProps.executeRecaptcha(
      "homepage"
    );
    this.setState({ token });
    //console.log(token);
  }

  renderError({ error, touched }) {
    if (touched && error) {
      return (
        <div className="invalid-feedback d-block">
          <div className="header">
            <strong>{error}</strong>
          </div>
        </div>
      );
    }

    return (
      <div className="d-block">
        <div className="header">&nbsp;</div>
      </div>
    );
  }

  renderInput = ({ placeholder, input, label, meta, type, disabled }) => {
    return (
      <div className="form-group m-0">
        {label && (
          <label className="form-label text-uppercase small">{label}</label>
        )}
        <input
          {...input}
          className="form-control"
          type={type}
          placeholder={placeholder}
          disabled={disabled}
        />
        {this.renderError(meta)}
      </div>
    );
  };

  renderTextArea = ({ placeholder, input, label, meta, type }) => {
    return (
      <div className="form-group">
        <label className="form-label text-uppercase small">{label}</label>
        <textarea
          {...input}
          className="form-control"
          placeholder={placeholder}
          rows="4"
        />
        {this.renderError(meta)}
      </div>
    );
  };

  renderCheckBox = ({ placeholder, input, label, meta, type }) => {
    return (
      <div>
        <div className="form-check form-check-inline">
          <input {...input} className="form-check-input" type={type} />
          <label
            title=""
            htmlFor="inline-checkbox-1"
            className="form-check-label"
          >
            {label}
          </label>
        </div>
      </div>
    );
  };

  renderSelect = ({
    placeholder,
    asyncValidating,
    input,
    label,
    meta,
    children,
  }) => {
    const className = `form-group text-uppercase small`;
    return (
      <div className={className}>
        {label && <label>{label}</label>}
        <select {...input} className="form-control">
          {children}
        </select>
      </div>
    );
  };

  renderRadio = ({
    placeholder,
    asyncValidating,
    input,
    label,
    meta,
    children,
  }) => {
    const className = `form-group col-md-4`;
    const values = children;
    return (
      <>
        <label className="form-label text-uppercase small">{label}</label>
        <div className="mb-3">
          {values.map((value, num) => (
            <div className="small form-check form-check-inline" key={num + 1}>
              <input
                {...input}
                type="radio"
                name="preferredContact"
                id={`inline-radio-${num + 1}`}
                className="form-check-input"
                value={value.props.label}
              />
              <label
                title=""
                htmlFor={`inline-radio-${num + 1}`}
                className="form-check-label"
              >
                {value.props.label}
              </label>
            </div>
          ))}
          {this.renderError(meta)}
        </div>
      </>
    );
  };

  onSubmit = async (formValues) => {
    // const message = {
    //   title: "test",
    //   message: "message",
    //   email: "email"
    // };

    //console.log(this.state.token);

    const message = emailBody(formValues);

    ReactGA.event({
      category: "ENQUIRY",
      action: `enquiry for ${formValues.subject}`,
      label: "NEW ENQUIRY",
    });

    let emailMessage = {
      application: "default",
      subject: `Viva Holidays Enquiry Regarding: ${formValues.subject}`,
      //emailTo: ["reservations@vivaholidays.com.au"],
      emailTo: ["online.enquiries@vivaholidays.com.au"],
      emailBcc: ["Melissa.Warren@helloworld.com.au"],
      name: "Name: Ken",
      emailBody: `${message}`,
      token: `${this.state.token}`,
    };

    let res = await sendEmail(emailMessage);
    res.status == 200 && this.setState({ messageFlag: true });
    //this.props.subscribe(formValues.email);
  };

  render() {
    const { handleSubmit, formValues } = this.props;

    const subscribed = this.props.subscribed;
    const upper = (value) => value && value.toUpperCase().trim();
    const lower = (value) => value && value.toLowerCase().trim();
    const capitalize = (value) =>
      value.charAt(0).toUpperCase().trim() + value.slice(1);

    let subscription = (
      <div>
        <label htmlFor="inputEmail" className="sr-only">
          Email address
        </label>
        <input
          type="email"
          id="inputEmailSubscribe"
          className="form-control mb-2"
          placeholder="Email address"
          required
          autoFocus
        />
        <button
          className="text-uppercase btn btn-lg btn-custom btn-block"
          onClick={this.subscribe}
          type="submit"
        >
          Subscribe
        </button>
      </div>
    );

    if (subscribed) {
      subscription = (
        <div className="text-center pb-2">
          <label className="text-primary font-weight-bold">
            Subscription Successful
          </label>
        </div>
      );
    } else {
      subscription = (
        <div>
          <label htmlFor="inputEmail" className="sr-only">
            Email address
          </label>
          <input
            type="email"
            id="inputEmailSubscribe"
            className="form-control mb-2"
            placeholder="Email address"
            required
            autoFocus
          />
          <button
            className="text-uppercase btn btn-lg btn-custom btn-block"
            onClick={this.subscribe}
            type="submit"
          >
            Subscribe
          </button>
        </div>
      );
    }

    let list = [];

    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <Field
          name="subject"
          component={this.renderInput}
          label="Name of Package*"
          placeholder=""
          disabled={true}
          //normalize={capitalize}
        />

        <Field
          name="enqType"
          component={this.renderSelect}
          label="Enquiry Type"
        >
          <option value="Accommodation Only">Accommodation Only</option>
        </Field>

        <div className="text-uppercase small mt-5">
          <label>Contact Details*</label>
        </div>
        <Row>
          <Col xs="12" sm="12" md="2">
            <Field name="enquiryTitle" component={this.renderSelect}>
              <option value="0">Title...</option>
              <option value="Mr">Mr</option>
              <option value="Mrs">Mrs</option>
              <option value="Miss">Miss</option>
              <option value="Mrs">Ms</option>
            </Field>
          </Col>
          <Col xs="12" sm="12" md="5">
            <Field
              name="firstName"
              component={this.renderInput}
              //label="First Name *"
              placeholder="First Name*"
              normalize={capitalize}
            />
          </Col>
          <Col xs="12" sm="12" md="5">
            <Field
              name="lastName"
              component={this.renderInput}
              //label="Last Name *"
              placeholder="Last Name*"
              normalize={capitalize}
            />
          </Col>
        </Row>

        <Row className="mb-4">
          <Col xs="12" sm="12" md="2">
            <Field name="phoneCode" component={this.renderSelect}>
              {_.map(phoneCodes(), (code) => {
                return (
                  <option
                    key={uuid()}
                    value={code.code}
                  >{`${code.name} (${code.code})`}</option>
                );
              })}
            </Field>
          </Col>
          <Col xs="12" sm="12" md="5">
            <Field
              name="phone"
              component={this.renderInput}
              //label="Phone Number"
              placeholder="Phone Number*"
              type="number"
            />
          </Col>
          <Col xs="12" sm="12" md="5">
            <Field
              name="email"
              component={this.renderInput}
              //label="Email"
              placeholder="Email Address*"
              normalize={lower}
            />
          </Col>
        </Row>

        <Row className="mb-4">
          <Col xs="12" sm="12" md="4">
            <Field
              name="travelDates"
              component={DateRangePickerField}
              label="Preferred Travel Dates*"
            />
          </Col>
          <Col xs="12" sm="12" md="4">
            <Field
              name="departCity"
              component={this.renderInput}
              label="Departure City*"
              placeholder="Departure City"
            />
          </Col>
          <Col xs="12" sm="12" md="4">
            <Field
              name="noNights"
              component={this.renderInput}
              label="Number of Nights*"
              placeholder=""
            />
          </Col>
        </Row>

        <Row className="mb-4">
          <Col xs="12" sm="12" md="4">
            <Field name="noAdult" component={this.renderSelect} label="Adult">
              {[...Array(9).keys()].map((id) => {
                return <option value={id + 1}>{id + 1}</option>;
              })}
              <option value="10+">10+</option>
            </Field>
          </Col>
          <Col xs="12" sm="12" md="4">
            <Field
              name="noChild"
              component={this.renderSelect}
              label="Children + Infant"
            >
              {[...Array(10).keys()].map((id) => {
                return <option value={id}>{id}</option>;
              })}
            </Field>
          </Col>
		    <Col xs="12" sm="12" md="4">
            <Field
              name="childAges"
              component={this.renderInput}
              label="Children Ages*"
              placeholder="Children ages, comma separated eg. 3, 5, 8"
            />
          </Col>
        </Row>

        <Row>
          <Col xs="12" sm="12" md="4">
            <Field
              name="discCode"
              component={this.renderInput}
              label="Discount Code"
              placeholder="Discount/Promo Code"
              normalize={upper}
              //normalize={capitalize}
            />
          </Col>
          {formValues.enqType === "Airfares & Accommodation" && (
            <Col xs="12" sm="12" md="4">
              <Field
                name="prefAirline"
                component={this.renderInput}
                label="Preferred Airline"
                placeholder="Preferred Airline"
                normalize={capitalize}
                //normalize={capitalize}
              />
            </Col>
          )}
        </Row>

        {/*
        <Field
          name="contact"
          component={this.renderInput}
          label="Contact Number"
          placeholder="0488 888 888"
          type="number"
        /> */}
        
		<Field
          name="additionalarrangements"
          component={this.renderTextArea}
          label="ADDITIONAL ARRANGEMENTS:"
          placeholder="Please advise of any additional arrangements we can assist you with such as sightseeing, activities, transfers, car hire etc."
        />
		
        <Field
          name="message"
          component={this.renderTextArea}
          label="YOUR REQUEST/MESSAGE:*"
          placeholder="Please provide as much  as possible so we can assist with your enquiry."
        />

        <Field
          name="preferredContact"
          component={this.renderRadio}
          label="Preferred Method of Contact*"
        >
          <Field type="radio" name="preferredContact" label="Phone" />

          <Field type="radio" name="preferredContact" label="Email" />
        </Field>

        {/* <Field
          component={this.renderCheckBox}
          label="Subscribe to our latest deals"
          type="checkbox"
          name="subscribe"
        /> */}
        <button
          className="text-uppercase btn btn-custom mt-3 mb-3"
          disabled={this.state.messageFlag}
        >
          ENQUIRE
        </button>
        {this.state.messageFlag && <h5>Enquiry Sent Successfully</h5>}
      </form>
    );
  }
}

const validate = (formValues) => {
  const errors = {};
  const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!formValues.email || !regexp.test(formValues.email)) {
    errors.email = "Please enter a valid email";
  }

  if (!formValues.subject) {
    errors.subject = "Please provide a subject";
  }

  if (!formValues.firstName) {
    errors.firstName = "Please enter a valid First Name";
  }

  if (!formValues.lastName) {
    errors.lastName = "Please enter a valid Last Name";
  }

  // if (!formValues.contact || !/^([0-9][0-9]{9})$/i.test(formValues.contact)) {
  //   errors.contact = "Invalid phone number, must be 10 digits";
  // }

  if (!formValues.preferredContact) {
    errors.preferredContact = "Please select a preferred method of contact";
  }

  if (!formValues.departCity) {
    errors.departCity = "Please provide a departure city";
  }

  // if (!formValues.phone || !/^([0-9][0-9]{9})$/i.test(formValues.phone)) {
  //   errors.phone = "Invalid phone number, must be 10 digits";
  // }

  if (!formValues.phone || formValues.phone.length < 10) {
    errors.phone = "Invalid phone number, must be at least 10 digits";
  }

  if (!formValues.message) {
    errors.message = "Please enter a message";
  }

  if (!formValues.travelDates) {
    errors.travelDates = "Please select your preferred travel dates";
  }
 
  if (Number(formValues.noChild) > 0 ) {
	  if(!formValues.childAges || formValues.childAges.length < 1){
	     errors.childAges = "Please enter children ages.";
	  } else {
		  const ages = formValues.childAges.split(",");
		  if(ages.length != Number(formValues.noChild)){
			  errors.childAges = "Please enter "+ Number(formValues.noChild) + " children ages.";
		  }
	  }
  }
  

  return errors;
};

const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector("enquiryForm");
  const enqTypeValue = selector(state, "enqType");
  const formValues = { enqType: enqTypeValue };

  return {
    formValues,
    mail: state.mail,
    subscribe: state.subscribe,
    initialValues: {
      subject: ownProps.title,
      noNights: ownProps.nights,
      email: "",
      phoneCode: "+61",
      //enqType: "Airfares & Accommodation",
      enqType: "Accommodation Only",
      noAdult: 1,
      noChild: 0,
	  childAges: "",
//      noInfant: 0,
      dealURL: ownProps.dealURL,
    },
  };
};

const EnquiryFormRecaptcha = withGoogleReCaptcha(EnquiryForm);

export default connect(
  mapStateToProps,
  {}
)(
  reduxForm({
    form: "enquiryForm",
    // initialValues: {
    //   email: "",
    //   subject: {props.title}
    // },
    validate,
    enableReinitialize: true,
    destroyOnUnmount: false,
  })(EnquiryFormRecaptcha)
);
